import { useStationsFinder } from './useStations';
import { Station } from '@app/core/types/stations';

/**
 * Returns the station for the given id or slug from the app data store, or null if not found.
 */
export function useStation(idOrSlug: string): Station {
  const finder = useStationsFinder();
  const station = finder(idOrSlug);

  if (!station) {
    throw new Error(`Station with id ${idOrSlug} not found in state!`);
  }

  return station;
}
